import React from "react";

import { AddToSelectionBtn, AddToSelectionQuantity, ProductSelectBtn } from "../styles";


const AddToSelection = ({
  product,
  handleAddItem,
  selection,
  updateItemRemove,
}) => {
  const getItemQuantity = (product) => {
    let match = 0;
    selection.forEach((x) => {
      if (x !== null) {
        x.id === product.variantID || x.variantID === product.variantID
          ? match++
          : null;
      }
    });
    return match;
  };

  return (
    <>
      {!getItemQuantity(product) ? (
        <ProductSelectBtn
          onClick={() => {
            handleAddItem(
              product.title,
              product.frontend_title,
              product.productID,
              product.variantID,
              product.limitedAvailability,
              product.price,
              product.img,
              product.personalisation_available,
              product.character_limit,
              false
            );
          }}
        >
          Add to Box
        </ProductSelectBtn>
      ) : (
        <AddToSelectionQuantity>
          <span onClick={() => updateItemRemove(product.variantID)}>-</span>
          <span>{getItemQuantity(product)}</span>
          <span
            onClick={() => {
              handleAddItem(
                product.title,
                product.frontend_title,
                product.productID,
                product.variantID,
                product.limitedAvailability,
                product.price,
                product.img,
                product.personalisation_available,
                product.character_limit,
                false
              );
            }}
          >
            +
          </span>
        </AddToSelectionQuantity>
      )}
    </>
  );
};

export default AddToSelection;
